<template>
  <div class="spo-avatar">
    <a-dropdown :trigger="['click']" v-model:visible="visible">
      <span class="ant-dropdown-link">
        <UserOutlined />
        <caret-down-outlined />
      </span>
      <template v-slot:overlay>
        <a-menu @click="handleMenuClick">
          <a-menu-item>
            <a-form-item style="margin-bottom: 0" label="User:">
              {{ username }}
            </a-form-item>
          </a-menu-item>
          <a-menu-item>
            <a-form-item label="Net Group:" style="margin-bottom: 0">
              <a-select
                v-model:value="netGroupValue"
                style="width: 180px"
                :dropdownMatchSelectWidth="200"
                @change="netGroupChange"
              >
                <a-select-option
                  v-for="item in netGroupList"
                  :key="item.id"
                  :value="item.netGrpId"
                >
                  {{ item.netGrpName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-menu-item>
          <a-menu-divider />
          <div class="btn-group">
            <a-button @click="logout" type="primary">Log Out</a-button>
          </div>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script>
  import { recordRoute } from '@/config'
  import { CaretDownOutlined, UserOutlined } from '@ant-design/icons-vue'

  import { useStore } from 'vuex'
  import { computed, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { Modal } from 'ant-design-vue'
  import { Dialog } from 'vant'
  export default {
    name: 'VabAvatar',
    components: { CaretDownOutlined, UserOutlined },
    setup() {
      const store = useStore()
      const router = useRouter()
      const route = useRoute()
      const visible = ref(false)
      const menu = computed(() => store.getters['routes/menu'])
      const isMobile = computed(
        () => store.getters['settings/device'] === 'mobile'
      )
      const logout = () => {
        if (isMobile.value) {
          Dialog.confirm({
            title: 'Are you sure you want to logout?',
          }).then(async () => {
            await store.dispatch('user/logout')
            if (recordRoute) {
              const fullPath = route.fullPath
              router.push(`/login?redirect=${fullPath}`)
            } else {
              router.push('/login')
            }
          })
        } else {
          Modal.confirm({
            title: 'Are you sure you want to logout?',
            async onOk() {
              await store.dispatch('user/logout')
              if (recordRoute) {
                const fullPath = route.fullPath
                router.push(`/login?redirect=${fullPath}`)
              } else {
                router.push('/login')
              }
            },
            onCancel() {},
          })
        }
      }
      const netGroupChange = async (e) => {
        const preNetGroup = store.getters['user/currentNetGroup']
        store.commit('user/setCurrentNetGroup', e)

        await store.dispatch('routes/getMenuList', e)
        if (menu.value.length) {
          if (route.params) {
            let searchRoute = []
            menu.value.forEach((item) => {
              const f = item.data.find((m) => m.url === route.name)
              if (f) {
                searchRoute.push(f)
              }
            })
            if (searchRoute.length) {
              const url = '/' + searchRoute[0].url + '/' + searchRoute[0].par
              router.push(url)
            }
          } else {
            location.reload()
          }
        } else {
          Modal.info({
            title: '提示',
            content: '当前Net Group无权限访问页面,按确定后取消操作',
            onOk: async () => {
              store.commit('user/setCurrentNetGroup', preNetGroup)
              await store.dispatch('routes/getMenuList', preNetGroup)
            },
          })
        }
      }
      const handleMenuClick = (e) => {
        console.log(e)
      }
      const netGroup = computed(() => store.getters['user/currentNetGroup'])
      return {
        username: computed(() => store.getters['user/username']),
        netGroup,
        netGroupList: computed(() => store.getters['user/netGroups']),
        netGroupValue: ref(netGroup),
        visible,
        logout,
        handleMenuClick,
        netGroupChange,
      }
    },
  }
</script>
<style lang="less" scoped>
  .spo-avatar {
    .ant-dropdown-link {
      display: flex;
      min-height: 32px;
      cursor: pointer;
      align-items: center;
      .anticon-user {
        background: #4d607b;
        color: #fff;
        font-size: 16px;
        width: 24px;
        line-height: 28px;
        height: 24px;
        padding: 0;
        display: inline-block;
        border-radius: 3px;
      }
    }
  }
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: end;
    padding: 5px 15px;
  }
  @media screen and (max-width: 720px) {
    .spo-avatar {
      .ant-dropdown-link {
        min-height: 32px;
        .anticon-user {
          font-size: 16px;
          width: 24px;
          line-height: 28px;
          height: 24px;
          border-radius: 3px;
        }
        .anticon-caret-down {
          display: none;
        }
      }
    }
  }
</style>
